import { TableCell, StatusCell } from 'ui/tableCell';
import type { CnameRowData } from '../types';

export const COLUMNS: CnameRowData[] = [
  {
    name: 'Name',
    align: 'flex-start',
    value: 'domain',
    sortable: false,
    RowCell: ({ row }) => <TableCell>{row.domain}</TableCell>,
  },
  {
    name: 'Type',
    align: 'flex-start',
    value: '',
    sortable: false,
    RowCell: () => <TableCell>CNAME</TableCell>,
  },
  {
    name: 'Status',
    align: 'flex-start',
    value: 'isVerified',
    sortable: false,
    RowCell: ({ row }) => (
      <StatusCell
        data-test="cname-table-status-cell"
        showPositiveState={row.isVerified}
        positiveLabel="Verified"
        negativeLabel="Unverified"
      />
    ),
  },
];
